import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPhoneAlt,faEnvelope} from '@fortawesome/free-solid-svg-icons';
import {faFacebook,faInstagram,faTwitter,faYoutube} from '@fortawesome/free-brands-svg-icons';
import './contact-heading.css';


function ContactHeading () {

    return (<div className='contact_heading_container'>
          <div className='contact_heading_email'>
                <a href="mailto:spspromoters2021theni@gmail.com" style={{textDecoration:'none' ,fontSize:'1rem'}}>
                <FontAwesomeIcon icon={faEnvelope} className="contact_email home_contact_icon" />
                    &nbsp; spspromoters2021theni@gmail.com
                    </a>
          </div>
          <div  className='contact_heading_phone' style={{marginRight:'20px'}}>
             <a href="tel:+919092423735" style={{textDecoration:'none', fontSize:'1rem'}}>
          <FontAwesomeIcon icon={faPhoneAlt} className='home_contact_icon'  /> 
                 +91 9092423735
                 </a>
          </div>
         
         <div className='contact_heading_socialmedia'>
         <a href="https://www.facebook.com/profile.php?id=100079113271137" rel="social media account">
          <FontAwesomeIcon icon={faFacebook} className="contact_heading_sm_icon" />
         </a>
         <a href="https://twitter.com/sps_promoters" rel="social media account">
          <FontAwesomeIcon icon={faTwitter} className="contact_heading_sm_icon" />
         </a>
         <a href="https://www.instagram.com/spspromoters/" rel="social media account">
          <FontAwesomeIcon icon={faInstagram} className="contact_heading_sm_icon" />
         </a>
         <a href="https://www.youtube.com/channel/UCl1wSuB7aNnQQ9Kj_Ovuiwg" rel="social media account">
          <FontAwesomeIcon icon={faYoutube} className="contact_heading_sm_icon" />
         </a>
         </div>

          <div className=''>

          </div>
    </div>)
}

export default ContactHeading;